import config from "../config"

export const PriceService = {
  getPriceLabel: (price: any, i18n: any) => {
    const formatted = PriceService.formatPrice(price.amountPerUnit, i18n)
    const pricelabel = formatted + " " + price.currency
    let pricingUnit = ""
    if (price.pricingUnit) {
      pricingUnit = PriceService.translatePricingUnit(price.pricingUnit, i18n)
    }
    if (pricingUnit) {
      return pricelabel + " / " + pricingUnit
    }
    return pricelabel
  },

  formatPrice: (price: any, i18n: any) => {
    if (typeof price !== "number") {
      return price
    }

    return new Intl.NumberFormat(i18n.locale, {
      style: "decimal",
      minimumFractionDigits: Number(config.priceMinFractionDigits)
    }).format(price)
  },

  translatePricingUnit: (pricingUnit: string, i18n: any) => {
    switch (pricingUnit) {
      case "KWH":
        return i18n.t("common.pricing.unitKWH")
      case "HOUR":
        return i18n.t("common.pricing.unitHOUR")
      case "MINUTE":
        return i18n.t("common.pricing.unitMINUTE")
      default:
        return ""
    }
  }
}
